import React from 'react';
import './ContentWrapper.less';

const ContentWrapper = React.memo(({ className, color, ...rest }) => (
  <div style={{ border: color, backgroundColor: color }} className={'content-wrapper'} {...rest} />
));

export default ContentWrapper;
